import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  Chip,
  Avatar,
  Rating,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { amerjeet, brigdhar, coachinghero, mahesh, nandhini } from "../../../../assets";
import CloseIcon from "@mui/icons-material/Close";
import CoachingPopup from "./CoachingPopup";
import { Fade, Zoom } from "@mui/material";


const HeroSection: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleScrollToPrograms = () => {
    const section = document.getElementById("premium-programs");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: 'auto', lg: "100vh" },
        display: "flex",
        alignItems: "center",
        color: "white",
        backgroundImage: `
 
    url("https://dprstorage.b-cdn.net/RW/leadgen/herosec2.png")
  `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="xl">
        <Box maxWidth="800px"

          sx={{
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            height: "100%",
            mt: 16,
            px: { xs: 2, lg: 10 },
          }}
        >

          {/* Top Badge */}
          <Chip
            icon={
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#ff2d2d",
                }}
              />
            }
            label="Premium Sales Coaching"
            sx={{
              backgroundColor: "rgba(255,255,255,0.08)",
              color: "white",
              backdropFilter: "blur(8px)",
              px: 2,
              py: 1,
              fontWeight: 500,
              mb: 2,
              width: "fit-content",
              "& .MuiChip-icon": {
                ml: 1,
              },
            }}
          />


          {/* Heading */}
          <Typography
            variant="h1"
            fontWeight={700}
            lineHeight={1.2}
            gutterBottom
            sx={{
              color: "white",
              fontSize: { xs: "2.2rem", md: "3rem", lg: "2.1rem" },
            }}
          >
            Transform Your Sales Performance With
            <span
              style={{
                display: "block",
                fontSize: "3.8rem",
                fontWeight: 800,
              }}
            >
              Structured Mastery
            </span>
          </Typography>

          {/* Subheading */}
          <Typography
            variant="h3"
            sx={{
              color: "#0f63a5",
              fontWeight: 600,
              mb: 2,
              fontSize: { xs: "1.5rem", md: "2rem", lg: "1.7rem" },
            }}
          >
            Elite Coaching for
            <span
              style={{
                display: "block",
                borderBottom: "4px solid #0080ff",
                width: "fit-content",
                paddingBottom: "4px",
                color: "#fff",
                // fontSize: { xs: "1.5rem", md: "2rem", lg: "2rem" },

              }}
            >
              High-Ticket Sales Professionals
            </span>
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            sx={{
              opacity: 0.85,
              mb: 4,
              fontSize: "1.1rem",
              color: "white",
            }}
          >
            Master the psychology, structure, & strategic framing required to handle high-ticket conversations with clarity & control. This is not motivation, it is disciplined sales execution.
          </Typography>

          {/* Buttons */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={4}>
            <Button
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={handleOpen}
              sx={{
                backgroundColor: "#0f63a5",
                px: 4,
                py: 1.5,
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#0c4e82",
                },
              }}
            >
              Book a Strategy Call
            </Button>

            <Button
              variant="outlined"
              startIcon={<PlayArrowIcon />}
              onClick={handleScrollToPrograms}
              sx={{
                borderColor: "white",
                color: "black",
                px: 4,
                py: 1.5,
                width: "fit-content",
                "&:hover": {
                  borderColor: "#0f63a5",
                  backgroundColor: "rgba(255,255,255,0.05)",
                  color: "white"
                },
              }}
            >
              Explore Coaching Programs
            </Button>
          </Stack>

          {/* Reviews Section */}
          {/* Reviews Section */}
          {/* Reviews Section */}
          <Stack
            direction="row"
            spacing={6}
            alignItems="flex-end"
            mb={2}
          >

            {/* Happy Clients */}
            <Stack spacing={1} alignItems="flex-start">
              {/* Avatars */}
              <Stack direction="row">
                {[
                  amerjeet,
                  mahesh,
                  brigdhar,
                  nandhini,
                ].map((src, index) => (
                  <Avatar
                    key={index}
                    src={src}
                    sx={{
                      width: 40,
                      height: 40,
                      border: "2px solid white",
                      ml: index !== 0 ? -1.5 : 0,
                    }}
                  />
                ))}
              </Stack>

              {/* Text */}
              <Typography variant="body2" sx={{ color: "white" }}>
                <strong>500+</strong> Professionals Mentored

              </Typography>
            </Stack>

            {/* Rating */}
            <Stack spacing={1} alignItems="flex-start" justifyContent="flex-end">
              {/* Stars */}
              <Rating value={5} readOnly sx={{ color: "#cb7e0b", textAlign: 'end' }} />

              {/* Text */}
              <Typography variant="body2" sx={{ color: "white", textAlign: 'end' }}>
                <strong>4.9 / 5</strong> Rating
              </Typography>
            </Stack>

          </Stack>


        </Box>
      </Container>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        // PaperProps={{
        //   sx: {
        //     borderRadius: "32px",
        //     background: "linear-gradient(145deg, #0c1f33, #124e78)",
        //     boxShadow: "0 40px 120px rgba(0,0,0,0.6)",
        //     overflow: "hidden",
        //     maxWidth: { xs: "95%", md: "50%" },
        //   },
        // }}

        TransitionComponent={Zoom}   // 🔥 Smooth scale
        transitionDuration={400}
        BackdropProps={{
          sx: {
            backdropFilter: "blur(8px)",   // 🔥 Backdrop blur
            backgroundColor: "rgba(0,0,0,0.6)",
          },
        }}
        PaperProps={{
          sx: {
            position: "relative",
            borderRadius: "32px",
            background: "linear-gradient(145deg, #0b0f1a, #101826)",
            boxShadow: "0 50px 140px rgba(0,0,0,0.7)",
            overflow: "hidden",
            maxWidth: { xs: "95%", md: "50%" },

            // 🔥 Gold border shimmer
            border: "1px solid rgba(20, 149, 209, 0.6)",

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(120deg, transparent, rgba(212,175,55,0.15), transparent)",
              animation: "shimmer 3s infinite",
            },

            "@keyframes shimmer": {
              "0%": { transform: "translateX(-100%)" },
              "100%": { transform: "translateX(100%)" },
            },
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <CoachingPopup handleClose={handleClose} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default HeroSection;
